import Role from "./Role.js";

/**
 * `BackOfficeRole` describes permissions of backoffice over other users.
 */
export default class BackOfficeRole extends Role {
	canDeleteUser(user) {
		return user
			.getRoles()
			.every((role) => role.canBeDeletedByBackOffice(this));
	}

	canAttachOrDetachCompanyId(user, companyId) {
		return user
			.getRoles()
			.some((role) =>
				role.canCompanyIdBeAttachedOrDetachedByBackOffice(
					this,
					companyId,
				),
			);
	}

	canEditUserInfo(user) {
		return user
			.getRoles()
			.some((role) => role.canUserInfoBeEditedByBackOffice(this));
	}

	canViewAccountingDocuments() {
		return true;
	}

	canViewBudgetEditor() {
		return true;
	}

	canAdministrateAgency() {
		return true;
	}

	canCreatePeriodReports() {
		return true;
	}

	canAdministrateDocumentArchive() {
		return true;
	}

	canEditLightCompanies() {
		return true;
	}

	canChangeCompanyPackage() {
		return true;
	}

	canManagePackages() {
		return true;
	}

	//
	// canUpgradeSubscriptionPlan
	//

	canUpgradeSubscriptionPlanForCompany() {
		return true;
	}

	canExtractDataFromCompany(_company) {
		return true;
	}

	canDeleteCompany(_company) {
		return true;
	}

	canShareChartOfAccounts() {
		return true;
	}
}
